<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M9.808 6.233q0-.55-.391-.941a1.28 1.28 0 0 0-.942-.392q-.167 0-.317.033a.9.9 0 0 0-.283.117l1.783 1.783a.9.9 0 0 0 .117-.283q.033-.15.033-.317m2.8 3.55-.966-.966q.416-.7.625-1.309.208-.608.208-1.141 0-1.817-1.158-2.975-1.16-1.16-2.842-1.159-.733 0-1.375.225t-1.158.659l-.95-.95a5.1 5.1 0 0 1 1.616-.942A5.5 5.5 0 0 1 8.475.9q2.117 0 3.725 1.483t1.608 3.984q0 .8-.3 1.641a8.8 8.8 0 0 1-.9 1.775m-2.616 1.184-5.45-5.45a6 6 0 0 0-.067.85q0 1.183.983 2.708t3.017 3.392q.433-.384.808-.759c.375-.375.486-.497.709-.741m4.133 4.133-3.2-3.2q-.534.567-1.133 1.15-.6.583-1.317 1.183-2.683-2.283-4.008-4.241-1.325-1.959-1.325-3.625a5.8 5.8 0 0 1 .317-1.933L.924 1.9l.95-.95 13.2 13.2z"
        />
    </svg>
</template>

<script setup lang="ts">
type LocationOffIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<LocationOffIconProps>();
</script>
